import { GET_USER_BUNDLES, GET_BUNDLE_WITH_ITEMS, CLEAR_SELECTED_BUNDLE, ACCEPT_BUNDLE_SALE } from 'actions/myAccount';

export default (state = null, action) => {
    switch (action.type) {
        case GET_USER_BUNDLES:
            return Object.assign({}, state, {bundles: action.payload});
        case GET_BUNDLE_WITH_ITEMS:
            return Object.assign({}, state, {selectedBundle: action.payload});
        case CLEAR_SELECTED_BUNDLE:
            return Object.assign({}, state, {selectedBundle: undefined});
        case ACCEPT_BUNDLE_SALE:
            return Object.assign({}, state, {transferDetails: action.payload});
    }

    return state;
}
